module.exports = __webpack_public_path__ + "f55860259d6ec5b4b44dd76b5e283af6.svg";